var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import * as Models from "../../../../../data/models";
export class OpenPulseBetViewModel extends Models.BasicPulseBetViewModel {
    constructor(stake, gain, pulseBetMetadata, startTimeOfBet, currentGameProgress, purchaseId, hasOddsChangedHandler, betAgainHandler, backToBetPlacementHandler, trackColor, bonusInfo) {
        super(stake, pulseBetMetadata, currentGameProgress);
        this.trackColor = trackColor;
        this.gain = gain;
        this.startTimeOfBet = startTimeOfBet;
        this.purchaseId = purchaseId;
        this.isFinished = false;
        this.hasOddsChangedHandler = hasOddsChangedHandler;
        this.betAgainHandler = betAgainHandler;
        this.backToBetPlacementHandler = backToBetPlacementHandler;
        this.progressInMilli = 0;
        this.animationStarted = Date.now();
        this.bonusInfo = bonusInfo;
    }
    get formatedGain() {
        return this.calculatedPeriodHelperDependency.formatWinnings(this.gain);
    }
    get uniqueKey() {
        return `purchaseId:${this.purchaseId}market:${this.pulseBetMetadata.marketId}`;
    }
    get periodFrames() {
        /* istanbul ignore next */
        let wrappedPeriods = this.calculatedPeriodHelperDependency.wrappedCalculatedPeriods(this.stake, this.pulseBetMetadata);
        return wrappedPeriods.map(p => ({
            start: p.absoluteToGameFormattedGameStart,
            end: p.absoluteGameFormattedGameEnd
        }));
    }
    isBetExpired() {
        let duration = 0;
        for (let period of this.pulseBetProgressData.periods) {
            duration += period.duration;
        }
        duration *= 1000;
        return this.isFinished || this.pulseBetProgressData.expiredBetProgressInMilliseconds >= duration;
    }
}
__decorate([
    observable,
    __metadata("design:type", Models.WinningsDataModel)
], OpenPulseBetViewModel.prototype, "winningsData", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], OpenPulseBetViewModel.prototype, "finishedState", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], OpenPulseBetViewModel.prototype, "isFinished", void 0);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], OpenPulseBetViewModel.prototype, "formatedGain", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], OpenPulseBetViewModel.prototype, "uniqueKey", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], OpenPulseBetViewModel.prototype, "periodFrames", null);
//# sourceMappingURL=OpenPulseBetViewModel.js.map